import React from "react";
import { Button, Space, Table, Tooltip, Typography } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import RequestStatusTag from "./RequestStatusTag";

const { Text } = Typography;

function formatDateTime(value) {
    if (!value) return "-";
    return new Date(value).toLocaleString();
}

function formatAmount(value) {
    if (value === null || value === undefined || value === "") return "-";
    const number = Number(value);
    if (!Number.isFinite(number)) return "-";

    return number.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
}

export default function CustomerRequestList({
    data = [],
    loading = false,
    pageSize = 10,
    compact = false,
}) {
    const navigate = useNavigate();

    const columns = [
        {
            title: "Request",
            key: "request",
            width: compact ? 220 : 260,
            render: (_, record) => (
                <Space direction="vertical" size={0}>
                    <Button
                        type="link"
                        style={{ padding: 0, height: "auto", fontWeight: 600 }}
                        onClick={() => navigate(`/requests/${record.id}`)}
                    >
                        {record.requestNumber || `#${record.id}`}
                    </Button>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        ID: {record.id}
                    </Text>
                </Space>
            ),
        },
        {
            title: "Institution",
            dataIndex: "institutionName",
            width: 220,
            ellipsis: true,
            render: (value) => value || <Text type="secondary">-</Text>,
        },
        {
            title: "Amount",
            key: "paymentAmount",
            width: 170,
            render: (_, record) => (
                <Space direction="vertical" size={0}>
                    <Text strong>{formatAmount(record.paymentAmount)}</Text>
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        {record.currency || "-"}
                    </Text>
                </Space>
            ),
        },
        {
            title: "Status",
            dataIndex: "customerSubmissionStatus",
            width: 160,
            render: (value) => <RequestStatusTag status={value} />,
        },
        {
            title: "Created",
            dataIndex: "createdAt",
            width: 190,
            render: (value) => (
                <Text type="secondary" style={{ fontSize: 12 }}>
                    {formatDateTime(value)}
                </Text>
            ),
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            width: 90,
            fixed: "right",
            render: (_, record) => (
                <Tooltip title="View details">
                    <Button
                        type="text"
                        icon={<EyeOutlined />}
                        onClick={() => navigate(`/requests/${record.id}`)}
                    />
                </Tooltip>
            ),
        },
    ];

    return (
        <Table
            rowKey="id"
            size={compact ? "small" : "middle"}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={
                pageSize
                    ? {
                          pageSize,
                          showSizeChanger: false,
                          hideOnSinglePage: data.length <= pageSize,
                      }
                    : false
            }
            scroll={{ x: 860 }}
            locale={{ emptyText: "No requests found" }}
        />
    );
}
